

exports.__esModule = true;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAuthorizationMessageComponent', {

    tag: 'xo-authorization-message',
    template: _template2['default']

});


_squid.$Component;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-authorization-message/directive.js
 ** module id = 386
 ** module chunks = 1
 **/